<template>
  <div class="section-browser">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">General Infomation</h1>
      </div>
      <div class="section-body" v-if="data && !isEmpty && !isError">
        <div class="item" v-for="(item,index) in data" v-bind:key="index">
          <div class="header">{{item.key}}</div>
          <div class="value">{{item.value}}</div>
        </div>
      </div>
      <EmptyMessage v-if="!isLoading && isEmpty && !isError">
        ไม่พบข้อมูลในช่วงเวลาดังกล่าว
      </EmptyMessage>
      <EmptyMessage v-if="!isLoading && isError">
        <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
        <p>
          โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
          <a
            :href="`mailto:support@byteark.com`"
            target="_top"
          >support@byteark.com</a>
        </p>
        <span slot="code" class="code">error code : {{error.status || 'not found' }}</span>
      </EmptyMessage>
      <div v-if="isLoading" class="d-flex justify-content-center">
        <div class="spinner-border" role="status" />
      </div>
    </Section>
  </div>
</template>

<script>
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: ['data', 'isLoading', 'isError', 'isEmpty', 'error'],
  components: {
    Section,
    EmptyMessage,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.item {
  margin: $spacer * 0.5;
  margin-left: 0;
  .value {
    font-size: $font-size-base * 1.15;
    color: #3c3c3c;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  .header {
    font-size: $font-size-base * 0.875;
    font-weight: 300;
    text-overflow: ellipsis;
    line-height: 1.5em;
    max-height: 1.5em;
    overflow: hidden;
  }
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
}

.flag-icon {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
}

@media (min-width: 320px) and (max-width: 767.98px) {
  .section-body {
    min-height: 250px;
  }

  .item {
    margin: $spacer * 0.5;
    .value {
      font-size: $font-size-base;
      color: #3c3c3c;
      text-overflow: ellipsis;
      overflow: hidden;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

    .header {
      font-size: $font-size-base * 0.75;
      font-weight: 300;
      text-overflow: ellipsis;
      line-height: 1.5em;
      max-height: 1.5em;
      overflow: hidden;
    }
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .item {
    margin: $spacer * 0.5;
    .value {
      font-size: $font-size-base;
      color: #3c3c3c;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

    .header {
      font-size: $font-size-base * 0.75;
      font-weight: 300;
    }
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
